/*
 * @beisen/bs-chart v0.1.19
 * (c) 2018 guomeishan
 * Released under the ISC License.
 * WARNING: The file is automatically generated, not manually modified. 
 * 警告: 该文件为脚本自动生成，切勿手动修改 
 */

import chart_ad942ac0c3ac11e897a789b71ff6d2fd from "./components/charts/china-map/index.vue"
import chart_ad9451d0c3ac11e897a789b71ff6d2fd from "./components/charts/data-grid-slider/index.vue"
import chart_ad9451d1c3ac11e897a789b71ff6d2fd from "./components/charts/diagram/index.vue"
import chart_ad9451d2c3ac11e897a789b71ff6d2fd from "./components/charts/histogram-v/index.vue"
import chart_ad9451d3c3ac11e897a789b71ff6d2fd from "./components/charts/histogram/index.vue"
import chart_ad9451d4c3ac11e897a789b71ff6d2fd from "./components/charts/number-v/index.vue"
import chart_ad9451d5c3ac11e897a789b71ff6d2fd from "./components/charts/pie/index.vue"
import chart_ad9451d6c3ac11e897a789b71ff6d2fd from "./components/charts/text-printer/index.vue"
import chart_ad9451d7c3ac11e897a789b71ff6d2fd from "./components/charts/text-printer/printer-item.vue"
import chart_ad9451d8c3ac11e897a789b71ff6d2fd from "./components/charts/text-slider/index.vue"
import chart_ad9451d9c3ac11e897a789b71ff6d2fd from "./components/charts/topological/index.vue"
import chart_ad9451dac3ac11e897a789b71ff6d2fd from "./components/charts/world-map/index.vue"
import chart_ad9451dbc3ac11e897a789b71ff6d2fd from "./components/fragment/number-with-bg/index.vue"
import chart_ad9451dcc3ac11e897a789b71ff6d2fd from "./components/fragment/number/index.vue"
import chart_ad9451ddc3ac11e897a789b71ff6d2fd from "./components/fragment/scale-tool/index.vue"
import chart_ad9451dec3ac11e897a789b71ff6d2fd from "./components/layouts/app-root/index.vue"
import chart_ad9451dfc3ac11e897a789b71ff6d2fd from "./components/layouts/china-map-layout/index.vue"
import chart_ad9451e0c3ac11e897a789b71ff6d2fd from "./components/layouts/date-tool/index.vue"
import chart_ad9451e1c3ac11e897a789b71ff6d2fd from "./components/layouts/header/index.vue"
import chart_ad9451e2c3ac11e897a789b71ff6d2fd from "./components/layouts/layout-card/index.vue"
import chart_ad9451e3c3ac11e897a789b71ff6d2fd from "./components/layouts/layout-contest/index.vue"
import chart_ad9451e4c3ac11e897a789b71ff6d2fd from "./components/layouts/page-footer/index.vue"
import chart_ad9451e5c3ac11e897a789b71ff6d2fd from "./components/layouts/page-layout/index.vue"
import chart_ad9451e6c3ac11e897a789b71ff6d2fd from "./components/layouts/world-map-layout/index.vue"
import formattings from "@utils/formattings"
require("@asserts/styles/all.css")

  let BSCharts = {
    components: {},
    formattings: formattings,
    version: '0.1.19'
  }

BSCharts.components[chart_ad942ac0c3ac11e897a789b71ff6d2fd.name] = chart_ad942ac0c3ac11e897a789b71ff6d2fd
BSCharts.components[chart_ad9451d0c3ac11e897a789b71ff6d2fd.name] = chart_ad9451d0c3ac11e897a789b71ff6d2fd
BSCharts.components[chart_ad9451d1c3ac11e897a789b71ff6d2fd.name] = chart_ad9451d1c3ac11e897a789b71ff6d2fd
BSCharts.components[chart_ad9451d2c3ac11e897a789b71ff6d2fd.name] = chart_ad9451d2c3ac11e897a789b71ff6d2fd
BSCharts.components[chart_ad9451d3c3ac11e897a789b71ff6d2fd.name] = chart_ad9451d3c3ac11e897a789b71ff6d2fd
BSCharts.components[chart_ad9451d4c3ac11e897a789b71ff6d2fd.name] = chart_ad9451d4c3ac11e897a789b71ff6d2fd
BSCharts.components[chart_ad9451d5c3ac11e897a789b71ff6d2fd.name] = chart_ad9451d5c3ac11e897a789b71ff6d2fd
BSCharts.components[chart_ad9451d6c3ac11e897a789b71ff6d2fd.name] = chart_ad9451d6c3ac11e897a789b71ff6d2fd
BSCharts.components[chart_ad9451d7c3ac11e897a789b71ff6d2fd.name] = chart_ad9451d7c3ac11e897a789b71ff6d2fd
BSCharts.components[chart_ad9451d8c3ac11e897a789b71ff6d2fd.name] = chart_ad9451d8c3ac11e897a789b71ff6d2fd
BSCharts.components[chart_ad9451d9c3ac11e897a789b71ff6d2fd.name] = chart_ad9451d9c3ac11e897a789b71ff6d2fd
BSCharts.components[chart_ad9451dac3ac11e897a789b71ff6d2fd.name] = chart_ad9451dac3ac11e897a789b71ff6d2fd
BSCharts.components[chart_ad9451dbc3ac11e897a789b71ff6d2fd.name] = chart_ad9451dbc3ac11e897a789b71ff6d2fd
BSCharts.components[chart_ad9451dcc3ac11e897a789b71ff6d2fd.name] = chart_ad9451dcc3ac11e897a789b71ff6d2fd
BSCharts.components[chart_ad9451ddc3ac11e897a789b71ff6d2fd.name] = chart_ad9451ddc3ac11e897a789b71ff6d2fd
BSCharts.components[chart_ad9451dec3ac11e897a789b71ff6d2fd.name] = chart_ad9451dec3ac11e897a789b71ff6d2fd
BSCharts.components[chart_ad9451dfc3ac11e897a789b71ff6d2fd.name] = chart_ad9451dfc3ac11e897a789b71ff6d2fd
BSCharts.components[chart_ad9451e0c3ac11e897a789b71ff6d2fd.name] = chart_ad9451e0c3ac11e897a789b71ff6d2fd
BSCharts.components[chart_ad9451e1c3ac11e897a789b71ff6d2fd.name] = chart_ad9451e1c3ac11e897a789b71ff6d2fd
BSCharts.components[chart_ad9451e2c3ac11e897a789b71ff6d2fd.name] = chart_ad9451e2c3ac11e897a789b71ff6d2fd
BSCharts.components[chart_ad9451e3c3ac11e897a789b71ff6d2fd.name] = chart_ad9451e3c3ac11e897a789b71ff6d2fd
BSCharts.components[chart_ad9451e4c3ac11e897a789b71ff6d2fd.name] = chart_ad9451e4c3ac11e897a789b71ff6d2fd
BSCharts.components[chart_ad9451e5c3ac11e897a789b71ff6d2fd.name] = chart_ad9451e5c3ac11e897a789b71ff6d2fd
BSCharts.components[chart_ad9451e6c3ac11e897a789b71ff6d2fd.name] = chart_ad9451e6c3ac11e897a789b71ff6d2fd

  BSCharts.install = function (Vue, options = {}) {
    Object.keys(this.components).forEach(name => {
      Vue.component(name, this.components[name])
    })
  }

export default BSCharts


// WEBPACK FOOTER //
// ./src/index.js